import { ripemd160 } from '@noble/hashes/ripemd160';
export function hashRipemd160(data) {
    return ripemd160(data);
}
//# sourceMappingURL=hashRipemd160.js.map